export const maxEntities = 100000;

export const tickRate = 60;

export const MAX_OBJECT_CAP = 100;

// no-op entity
export const NOOP = 0;
